import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import V2Referrals from '../admin/V2Referrals';
import V2AdminPageHeading from '../components/V2AdminPageHeading';

const V2AdminReferrals: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <V2AdminPageHeading
        title={t('admin_referrals_title')}
        description={t('admin_referrals_description')}
        action={
          <Link className="outline-button v2-admin-page-heading__action" to="/users">
            {t('admin_referrals_users')}
          </Link>
        }
      />
      <V2Referrals />
    </>
  );
};

export default V2AdminReferrals;
